/**
 * Toggle — 44×26 switch. Ported from design/project/lib/dash2.jsx;
 * pixel values live in the .ns-toggle classes in index.css.
 */
import type { ButtonHTMLAttributes } from "react";

export interface ToggleProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "onToggle"> {
  on: boolean;
}

export function Toggle({ on, className, ...rest }: ToggleProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={on}
      {...rest}
      className={["ns-toggle", on ? "on" : "", className ?? ""]
        .filter(Boolean)
        .join(" ")}
    />
  );
}
